module.exports = __webpack_public_path__ + "static/media/poster-ja.5dc80928.jpg";